import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CurorcComponent } from './curorc/curorc.component';
import { EntertainmentComponent } from './entertainment/entertainment.component';
import { FinanceComponent } from './finance/finance.component';
import { ManufacturingComponent } from './manufacturing/manufacturing.component';
import { OuropinionCasestudyComponent } from './ouropinion-casestudy/ouropinion-casestudy.component';
import { RetailComponent } from './retail/retail.component';
import { FutekCasestudyComponent } from './futek-casestudy/futek-casestudy.component';


export const routes: Routes = [
  { path: 'curorc', component: CurorcComponent },
  { path: 'entertainment', component: EntertainmentComponent },
  { path: 'finance', component: FinanceComponent },
  { path: 'manufacturing', component: ManufacturingComponent },
  { path: 'ouropinion-casestudy', component: OuropinionCasestudyComponent },
  { path: 'retail', component: RetailComponent },
  { path: 'futek-casestudy', component: FutekCasestudyComponent},

]

@NgModule({
  declarations: [],
  imports: [
  RouterModule.forChild(routes),
  CommonModule,
  ],  exports: [RouterModule]
})
export class IndustriesRoutingModule { }
